import React from 'react';
import { AlertTriangle, HelpCircle } from 'lucide-react';

/**
 * iOS-style confirmation sheet. Tier-2 of the confirmation policy:
 * used for destructive-but-recoverable actions (unassign, bulk unlock,
 * relay open, maintenance, forget device). Tier-3 (typed confirm) stays
 * bespoke where it exists (Clear All Lockers).
 */
const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'danger', // 'danger' | 'warning' | 'primary'
  busy = false,
}) => {
  if (!open) return null;

  const toneBtn = tone === 'danger' ? 'btn-danger' : tone === 'warning' ? 'btn-warning-solid' : 'btn-primary';
  const iconWrap =
    tone === 'danger' ? 'bg-danger-500/15 text-danger-400' :
    tone === 'warning' ? 'bg-warning-500/15 text-warning-400' :
    'bg-primary-500/15 text-primary-400';

  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[60] p-4"
      onClick={busy ? undefined : onClose}
    >
      <div
        className="glass-sheet p-6 w-full max-w-sm text-center animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`w-12 h-12 mx-auto mb-4 rounded-full flex items-center justify-center ${iconWrap}`}>
          {tone === 'primary' ? <HelpCircle className="w-6 h-6" /> : <AlertTriangle className="w-6 h-6" />}
        </div>
        <h3 className="text-title3 text-white mb-1.5">{title}</h3>
        {message && <p className="text-subheadline text-secondary mb-6">{message}</p>}
        <div className="flex space-x-3">
          <button className="btn btn-secondary flex-1" onClick={onClose} disabled={busy}>
            {cancelLabel}
          </button>
          <button className={`btn ${toneBtn} flex-1`} onClick={onConfirm} disabled={busy}>
            {busy ? 'Working...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
